import { render, staticRenderFns } from "./PendingAdminApprovalCampaigns.vue?vue&type=template&id=165ac846&"
import script from "./PendingAdminApprovalCampaigns.vue?vue&type=script&lang=ts&"
export * from "./PendingAdminApprovalCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports